import { useTranslation } from '@thoughtspot/i18n';
import { Icon, IconID, IconSize, } from '@thoughtspot/radiant-react/widgets/icon';
import cx from 'classnames';
import React, { useState } from 'react';
import styles from './user-menu.module.scss';
import { getUserThemeMode, setUserThemeMode, } from './user-theme-utils';
const MODES = [
    { id: 'light', labelKey: 'preference.themeMode.light' },
    { id: 'dark', labelKey: 'preference.themeMode.dark' },
    { id: 'system', labelKey: 'preference.themeMode.system' },
];
export const AppearanceSubmenu = ({ userId, }) => {
    const { t } = useTranslation();
    const [showSubmenu, setShowSubmenu] = useState(false);
    const [currentMode, setCurrentMode] = useState(() => getUserThemeMode(userId));
    const handleModeSelect = (mode) => {
        setUserThemeMode(userId, mode);
        setCurrentMode(mode);
        setShowSubmenu(false);
    };
    return (React.createElement("div", { className: styles.appearanceRow, onMouseEnter: () => setShowSubmenu(true), onMouseLeave: () => setShowSubmenu(false) },
        React.createElement("span", { className: styles.appearanceLabel, role: "menuitem", "aria-haspopup": "menu", "aria-expanded": showSubmenu, tabIndex: 0, onKeyDown: e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    setShowSubmenu(v => !v);
                }
            } }, t('preference.themeMode.label')),
        React.createElement(Icon, { id: IconID.CARET_RIGHT, size: IconSize.SMALL, className: styles.appearanceChevron }),
        showSubmenu && (React.createElement("div", { className: styles.appearanceSubmenu, role: "menu", "aria-label": t('preference.themeMode.label') }, MODES.map(({ id, labelKey }) => (React.createElement("div", { key: id, role: "menuitemradio", "aria-checked": currentMode === id, tabIndex: 0, className: styles.submenuOption, onClick: () => handleModeSelect(id), onKeyDown: e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    handleModeSelect(id);
                }
            } },
            React.createElement(Icon, { id: IconID.CHECKMARK, size: IconSize.SMALL, className: cx(styles.checkmark, {
                    [styles.checkmarkActive]: currentMode === id,
                }) }),
            t(labelKey))))))));
};
//# sourceMappingURL=appearance-submenu.js.map